
import BScroll from "@better-scroll/core"
import ware from "@/components/cms/ware.vue"
import { WARE_STATUS } from "@/constants/ware"

const fen2Yuan = num => {
  if (isNaN(num)) return ""
  num = Number(num)
  return (num / 100).toFixed(2).toString().split(".")
}
export default {
  name: "ProRec",
  components: {
    ware
  },
  props: {
    configData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      scroll: null,
      showArrow: true,
      showArrowLeft: false,
      wareData: [],
      groupTitle: "",
      styleConfig: {
        width: "1.96rem"
        // marginRight: ".1rem"
      },
      commonReqParams: {},
      curShow: 0
    }
  },
  watch: {
    configData: {
      handler(newVal) {
        this.wareData = this.transformData(newVal)
        if (this.wareData.length <= 6) {
          this.showArrow = false
        }
      },
      immediate: true
    }
  },
  created() {
    if (!process.client) {
      return
    }
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams
  },
  mounted() {
    const width = this.wareData.length * 1.96 + 0.08 * (this.wareData.length - 1)
    this.$refs.ware.style.width = width + "rem"
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.wareContent, {
        scrollX: true,
        click: true,
        probeType: 3,
        bounce: false,
        eventPassthrough: "vertical"
      })
      this.scroll.on("scroll", this.onScroll)
    })
  },
  methods: {
    transformData(data) {
      const result = []
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          const promotionPrice = data[i].additional?.promotionPrice
          const promotionPriceArr = fen2Yuan(promotionPrice)
          data[i].additional.promotionPriceVal = promotionPriceArr[0]
          data[i].additional.promotionPriceVal2 = promotionPriceArr[1]
          const nameArr = data[i].additional.name.split(" ")
          data[i].additional.nameVal = nameArr[0]
          data[i].additional.nameUnit = nameArr[1]
          data[i].additional.showSubTypeName =
            data[i].additional.promotionList && data[i].additional.promotionList.length > 1
              ? this.$t("common.multipleOffers")
              : data[i].additional.promotionList &&
                  data[i].additional.promotionList[0] &&
                  data[i].additional.promotionList[0].subTypeName
                ? data[i].additional.promotionList[0].subTypeName
                : ""
          data[i].additional.showSoldOut = [WARE_STATUS.OUT_OF_STOCK, WARE_STATUS.DISCONTINUED].includes(
            data[i].additional.wareStatus
          )
          data[i].additional.showComingSoon = [WARE_STATUS.COMING_SOON].includes(data[i].additional.wareStatus)
          result.push(data[i])
        }
      }
      return result
    },
    handleArrowClick(type) {
      console.log("handleArrowClick", type)
      // 单个商品宽度目前为196px ,一行显示6.5个
      const curLen = 6 * 196
      this.curShow = type === "left" ? this.curShow - 1 : this.curShow + 1
      if (this.curShow < 0) {
        this.curShow = 0
      }
      let num = curLen * this.curShow
      if (num > Math.abs(this.scroll.maxScrollX)) {
        num = Math.abs(this.scroll.maxScrollX)
      }
      const move = -num
      this.scroll.scrollTo(move, 0, 300)
    },
    onScroll(pos) {
      // 判断结束,完整可视商品目前为6个
      // console.log(`Now position is x: ${pos.x}, y: ${pos.y}`)
      const length = Math.ceil(Math.abs(pos.x / 195))
      if (pos.x == this.scroll.maxScrollX || (length && length == this.wareData.length - 6)) {
        this.showArrow = false
      } else {
        this.showArrow = true
      }
      this.showArrowLeft = Math.abs(pos.x) > 0
      this.$bus.$emit("handleCardsScroll")
    }
  }
}
